import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "strengthBar",
    "strengthText",
    "strengthIndicator",
    "lengthCheck",
    "numberCheck",
    "specialCheck",
    "submit",
  ];
  static values = {
    weak: String,
    fair: String,
    good: String,
    strong: String,
  };

  connect() {
    this.checkPassword();

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = true;
    }

    window.onTurnstileSuccess = () => {
      if (this.hasSubmitTarget) {
        this.submitTarget.disabled = false;
      }
    };

    window.onTurnstileError = () => {
      if (this.hasSubmitTarget) {
        this.submitTarget.disabled = true;
      }
    };

    window.onTurnstileExpired = () => {
      if (this.hasSubmitTarget) {
        this.submitTarget.disabled = true;
      }
      window.turnstile?.reset();
    };
  }

  togglePassword(event) {
    const button = event.currentTarget;
    const input = button.closest(".relative").querySelector("input");
    input.type = input.type === "password" ? "text" : "password";
  }

  checkPassword(event) {
    const password = event?.target?.value || "";
    const strength = this.calculateStrength(password);

    this.updateStrengthIndicator(strength);
    this.updateRequirements(password);
  }

  calculateStrength(password) {
    if (!password) return 0;
    let strength = 0;

    if (password.length >= 8) strength += 25;
    if (password.match(/[0-9]/)) strength += 25;
    if (password.match(/[a-z]/)) strength += 25;
    if (password.match(/[A-Z]/) || password.match(/[^a-zA-Z0-9]/))
      strength += 25;

    return strength;
  }

  updateStrengthIndicator(strength) {
    if (strength > 0) {
      this.strengthIndicatorTarget.classList.remove("hidden");
      this.strengthIndicatorTarget.classList.add("block");
    } else {
      this.strengthIndicatorTarget.classList.add("hidden");
      this.strengthIndicatorTarget.classList.remove("block");
    }

    this.strengthBarTarget.dataset.strength = strength;

    const colors = {
      25: "bg-red-500 strength-weak",
      50: "bg-yellow-500 strength-fair",
      75: "bg-blue-500 strength-good",
      100: "bg-green-500 strength-strong",
    };

    this.strengthBarTarget.className = `h-1.5 rounded-full strength-bar ${
      colors[strength] || "bg-gray-200"
    }`;

    const texts = {
      25: this.weakValue,
      50: this.fairValue,
      75: this.goodValue,
      100: this.strongValue,
    };

    this.strengthTextTarget.textContent = texts[strength] || "";
  }

  updateRequirements(password) {
    const check = "✓";
    const pending = "◦";

    if (this.hasLengthCheckTarget) {
      this.lengthCheckTarget.textContent = password.length >= 8 ? check : pending;
    }
    if (this.hasNumberCheckTarget) {
      this.numberCheckTarget.textContent = password.match(/[0-9]/) ? check : pending;
    }
    if (this.hasSpecialCheckTarget) {
      this.specialCheckTarget.textContent = password.match(/[^a-zA-Z0-9]/) ? check : pending;
    }
  }

  disconnect() {
    delete window.onTurnstileSuccess;
    delete window.onTurnstileError;
    delete window.onTurnstileExpired;
  }
}
